var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RESET_VALUE, SET_PURCHASE_DATA, SET_PURCHASE_FEE, SET_PURCHASE_MODE, SET_PAYMENT_SUCCESS, SET_REDEEM_DATA, SET_TOPUP_DATA, SET_TRANSER_IN_DATA, SET_UPLOAD_DECLARTION, SET_WATCHLIST_DATA, } from "../actions/PaymentAction";
import { EHoldingType } from "@domains/features/Markets/AIF-PMS/entities/PurchaseEntity";
var initialState = {
    purchase: {
        amount: "",
        formNo: "",
    },
    topup: {
        amount: "",
        folio: "",
    },
    redeem: {
        folio: "",
        redeemAmount: "",
        reason: "",
        totalqty: 0,
        marketvalue: 0,
        termAccepted: false,
        approxUnit: 0,
    },
    paymentMode: {
        type: EHoldingType.RTGS,
        bankName: {
            label: "",
            value: "",
        },
        rtgsNo: "",
    },
    purchaseFee: {
        setUpFees: "",
        sbName: "",
        passout: "",
    },
    arnTransfer: {
        transferIn: "",
        amount: "",
    },
    uploadDeclaration: [],
    watchListData: null,
    paymentSuccess: false,
};
var paymentFlow = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_PURCHASE_DATA:
            return __assign(__assign({}, state), { purchase: action.payload.purchase });
        case SET_TOPUP_DATA:
            return __assign(__assign({}, state), { topup: action.payload.topup });
        case SET_PURCHASE_MODE:
            return __assign(__assign({}, state), { paymentMode: action.payload.paymentMode });
        case SET_REDEEM_DATA:
            return __assign(__assign({}, state), { redeem: action.payload.redeem });
        case SET_PURCHASE_FEE:
            return __assign(__assign({}, state), { purchaseFee: action.payload.purchaseFee });
        case SET_UPLOAD_DECLARTION:
            return __assign(__assign({}, state), { uploadDeclaration: action.payload.uploadDeclaration });
        case SET_TRANSER_IN_DATA:
            return __assign(__assign({}, state), { arnTransfer: action.payload.arnTransfer });
        case SET_PAYMENT_SUCCESS:
            return __assign(__assign({}, state), { paymentSuccess: action.payload.paymentSuccess });
        case RESET_VALUE:
            return {
                purchase: {
                    amount: "",
                    formNo: "",
                },
                topup: {
                    amount: "",
                    folio: "",
                },
                redeem: {
                    folio: "",
                    redeemAmount: "",
                    reason: "",
                    totalqty: 0,
                    marketvalue: 0,
                    termAccepted: false,
                    approxUnit: 0,
                },
                paymentMode: {
                    type: EHoldingType.RTGS,
                    bankName: {
                        label: "",
                        value: "",
                    },
                    rtgsNo: "",
                },
                purchaseFee: {
                    setUpFees: "",
                    sbName: "",
                    passout: "",
                },
                arnTransfer: {
                    transferIn: "",
                    amount: "",
                },
                uploadDeclaration: [],
                watchListData: null,
                paymentSuccess: false,
            };
        case SET_WATCHLIST_DATA:
            return __assign(__assign({}, state), { watchListData: action.payload.watchListData });
        default:
            return state;
    }
};
export default paymentFlow;
